
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Home from './Home';
import Recipes from './Recipes';
import AddRecipe from './AddRecipe';
import WeeklyOverview from './WeeklyOverview';
import RecipeDetail from './RecipeDetail';

function App() {
  return (
    <Router>
      <div className="container mt-5">
        <h1 className="mb-4">Cooking Recipes</h1>

        <nav className="navbar navbar-expand-lg navbar-light bg-light mb-4">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/">Recipe App</Link>
            <div className="collapse navbar-collapse">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link className="nav-link" to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/recipes">All Recipes</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/add">Add Recipe</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/weekly-overview">Weekly Overview</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/add" element={<AddRecipe />} />
          <Route path="/weekly-overview" element={<WeeklyOverview />} />
          <Route path="/recipe/:id" element={<RecipeDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
